import Modal from '@src/common/Modal';
import { Link } from 'react-router-dom';

interface ClaimSuccessPopupProps {
    show: boolean;
    handleClose: () => void;
    leadId: number | null;
    popupText:string;
    payment_done : boolean;
}

function ClaimSuccessPopup({ show, handleClose,leadId,popupText,payment_done }: ClaimSuccessPopupProps) {
    return (
        <div className="model-outer upload-success-popup">
          <Modal show={show} handleClose={handleClose}>
            <div className="modal-body">
              <div className='upload-success-msg'>
                <div className='check-icn'>
                  <i className='ic-check'></i>
                </div>
                <span className='thanks-txt'>{popupText}</span>
                <div className='id-number'> Our team will get back to you shortly</div>
                {
                    !payment_done && 
                    <span className='thanks-txt'>Please make payment to proceed your claim</span>
                }
              </div>
            </div>
            <div className='modal-footer m-lg-t' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {
                !payment_done ?
                  <Link to={`/payment-add/${leadId}`} style={{ textAlign: 'center' }}>
                      <button className='btn-primary btn-white'>Okay</button>
                  </Link>
                :
                  <button className='btn-primary btn-white' onClick={handleClose}>Okay</button>

                }
            </div>
          </Modal>
        </div>
    );
}

export default ClaimSuccessPopup;